let new_collections = [
    {
        id : 1,
        name : "MARKS & SPENCER Solid Light Weight Wrap",
        image : "https://assets.ajio.com/medias/sys_master/root/20231031/MVkA/6540e559ddf779151964c0a2/-1117Wx1400H-462914270-beige-MODEL.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 2,
        name : "ZALIO Embroidered Full-Sleeve Shirt Dress",
        image : "https://assets.ajio.com/medias/sys_master/root/20230624/yqy7/6496a12aeebac147fcf974f8/-1117Wx1400H-465543380-blue-MODEL.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 3,
        name : "DNMX Men Printed Slim Fit Shirt",
        image : "https://assets.ajio.com/medias/sys_master/root/20230630/2E5F/649ef8e3a9b42d15c92dbb1c/-1117Wx1400H-443016515-green-MODEL.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 4,
        name : "FIG Floral Print V-Neck Top",
        image : "https://assets.ajio.com/medias/sys_master/root/20230213/ChYh/63ea1244f997dde6f4a03ca6/-1117Wx1400H-443007168-beige-MODEL.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 5,
        name : "ZALIO Girls Minnie Mouse Print Dungaree with T-Shirt",
        image : "https://assets.ajio.com/medias/sys_master/root/20231101/pjDt/6541ffb3ddf77915196742ad/-1117Wx1400H-466762507-seagreen-MODEL3.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 6,
        name : "GAP Regular Fit Cotton Crew-Neck T-Shirt",
        image : "https://assets.ajio.com/medias/sys_master/root/20230831/482v/64f0a8bfafa4cf41f59b1cf1/-1117Wx1400H-442111596-black-MODEL.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 7,
        name : "AARKE RITU KUMAR Embroidered Kurta & Pant Set",
        image : "https://assets.ajio.com/medias/sys_master/root/20231127/y9JD/6564ad2eafa4cf41f5a3d001/-1117Wx1400H-410334695-chocolatebrown-MODEL.jpg",
        new_price : 85.00,
        old_price : 120.00
    },
    {
        id : 8,
        name : "FORCE Men Geometric Print Regular Fit Shirt",
        image : "https://assets.ajio.com/medias/sys_master/root/20231116/PUPm/65554b10afa4cf41f58afbf0/-1117Wx1400H-466800479-white-MODEL2.jpg",
        new_price : 85.00,
        old_price : 120.00
    }
]

export default new_collections